import React from "react";
//#region
import { useSelector } from "react-redux";
import { AppState } from "store";
//#endregion
//#region types
import { TranslationKeys } from "translations";
import { ACTION_SEPARATOR } from "models/propTypes/menuPropTypes";
import { SupportFormTypes } from "models/formTypes";
import { WintSuperkollAPIModelCustomFilters } from "wint-api-client/dist/types";
import { ReportConstants, TableConstants } from "utils/constants";
//#endregion
//#region components
import SupportTeamBanner from "./supportTeamBanner";
import SupportCaseReportTopBanner from "./reportTopBanner";
import SupportIssuesList from "./list";
import useSupportIssueFilterDefinition from "./forms/useSupportIssueFilterDefinition";
import {
  DashboardButtonGroup,
  FilterButton,
  PageLayouts,
  ReloadEvent,
  ReportSearchInput,
  SearchContextProvider,
  TableContextProvider,
  useCheckRelations,
} from "components/common";
import { Grid } from "@mui/material";
import { useSupportService } from "serviceHooks";
//#endregion
import { useSupportTeamContent } from "serviceHooks/useSupportTeamContent";
import { LocalizationHelperInstance } from "utils/helpers";

const SupportCaseReport: React.FC = () => {
  const supportService = useSupportService();
  const { filterFormFields, filterQueryStateHandler, apiToReportFilterFormatter } = useSupportIssueFilterDefinition();
  const loggedInUser = useSelector((state: AppState) => state.auth.loggedInUser);
  const companyId = useSelector((state: AppState) => state.auth.selectedCompany.id);
  const supportTeamData = useSupportTeamContent(companyId);

  const { getIsAdmin } = useCheckRelations();
  const isAdmin = getIsAdmin();

  return (
    <ReloadEvent
      uniqueKey={ReportConstants.ReportKeys.Support}
      render={(reloadKey, reload) => (
        <SearchContextProvider>
          <PageLayouts.DashboardLayout<SupportFormTypes.Filter>
            entityKey={0}
            title={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Support)}
            topRightButtons={
              <DashboardButtonGroup
                buttons={[
                  <ReportSearchInput
                    placeholder={LocalizationHelperInstance.getFormattedMessage(
                      TranslationKeys.SupportIssue.SearchFilter
                    )}
                  />,
                  ACTION_SEPARATOR,
                  <FilterButton />,
                ]}
              />
            }
            filterFields={filterFormFields}
            initialFilter={isAdmin ? { userId: loggedInUser.personId, userName: loggedInUser.name } : {}}
            filterQueryStateHandler={filterQueryStateHandler}
            apiToReportFilterFormatter={apiToReportFilterFormatter}
            reportToAPIFilterFormatter={supportService.supportFilterToAPIFilter}
            filterCategory={WintSuperkollAPIModelCustomFilters.FilterCategory.Support}
          >
            <Grid container item>
              <TableContextProvider tableKey={TableConstants.SupportList}>
                <SupportIssuesList reloadKey={reloadKey} reloadSupportCases={reload} />
              </TableContextProvider>
            </Grid>
            <Grid container item>
              <SupportTeamBanner supportTeamData={supportTeamData} />
              <SupportCaseReportTopBanner reloadSupportCases={reload} supportTeamData={supportTeamData} />
            </Grid>
          </PageLayouts.DashboardLayout>
        </SearchContextProvider>
      )}
    />
  );
};

export default SupportCaseReport;
